@use '../colors.scss' as colors;

.processing {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-weight: 300;
  text-align: center;

  .processing-label {
    font-weight: 400;
    margin-bottom: 10px;
    color: colors.$label;
    font-size: 18px;
    padding: 0;
  }
}
